import { array, bool } from 'prop-types'
import { useEffect, useState } from 'react'
import { kuiperClassNames } from '@opallabs/kuiper'
import { isInWorkflowPopover } from '../../helpers/matchers'
import Phase from '../../Phase'
import PhasePlaceholder from '../../PhasePlaceholder'
import { newPhaseDefaults, titlesByType } from '../helpers/helpers'
import phaseContainerContext from './phaseContainerContext'

const isAfterActivePhase = (phases, idx) => {
  const previousPhase = phases[idx - 1]
  if (previousPhase) {
    return previousPhase.is_active
  }
  return false
}

const createPhaseOfType = (update, phaseType) => {
  update({
    ...newPhaseDefaults(phaseType),
    phase_type: phaseType,
    name: titlesByType[phaseType],
  })
}

const PhaseRenderer = ({
  isLimitedRole,
  isUpdatingLocalPhase,
  isWorkflowTemplate,
  items,
  skipCompletedPhases,
  ...otherProps
}) => {
  const { loading, workflowLocation } = otherProps

  if (skipCompletedPhases && otherProps.is_complete) {
    return null
  }

  if (otherProps.phase_type || otherProps.type) {
    const localLoading = isUpdatingLocalPhase ? true : loading

    return (
      <Phase
        {...otherProps}
        currentUser={otherProps.currentUser}
        isAfterActivePhase={isAfterActivePhase(items, otherProps.idx)}
        isLimitedRole={isLimitedRole}
        isWorkflowTemplate={isWorkflowTemplate}
        loading={localLoading}
      />
    )
  }

  if (isInWorkflowPopover(workflowLocation)) {
    return <PhasePlaceholder disablePhaseCreation={true} loading={loading} />
  }

  return (
    <PhasePlaceholder
      loading={loading}
      onCancel={otherProps.remove}
      onSetAsApprovalPhase={() =>
        createPhaseOfType(otherProps.update, 'approval')
      }
      onSetAsTaskPhase={() => createPhaseOfType(otherProps.update, 'task')}
      shouldDisableApprovalPhaseButton={otherProps.finalApprovalReached}
      shouldRenderCancelButton={items.length > 1}
    />
  )
}

PhaseRenderer.propTypes = {
  isLimitedRole: bool,
  isUpdatingLocalPhase: bool,
  isWorkflowTemplate: bool,
  items: array,
  skipCompletedPhases: bool,
}

const PhaseContainer = ({
  isLimitedRole,
  isWorkflowTemplate,
  items,
  skipCompletedPhases,
  ...otherProps
}) => {
  const [isUpdatingLocalPhase, setIsUpdatingLocalPhase] = useState(false)
  const [localStatus] = useState(otherProps.status)

  useEffect(() => {
    if (otherProps.status !== localStatus && otherProps.status === 'denied') {
      setIsUpdatingLocalPhase(false)
    }
  }, [otherProps.status, localStatus])

  return (
    <div className={kuiperClassNames('phaseList-item', 'hasBgColor')}>
      <phaseContainerContext.Provider value={{ setIsUpdatingLocalPhase }}>
        <PhaseRenderer
          isLimitedRole={isLimitedRole}
          isUpdatingLocalPhase={isUpdatingLocalPhase}
          isWorkflowTemplate={isWorkflowTemplate}
          items={items}
          skipCompletedPhases={skipCompletedPhases}
          {...otherProps}
        />
      </phaseContainerContext.Provider>
    </div>
  )
}

PhaseContainer.propTypes = {
  isLimitedRole: bool,
  isWorkflowTemplate: bool,
  items: array,
  skipCompletedPhases: bool,
  workflowStarted: bool,
}

export default PhaseContainer
